import { Edit, SimpleForm } from "react-admin";
import { GeoForm } from "./geo-integration-form";

export const GeoEdit = ({ permissions, ...props }) =>  (
    <Edit { ...props }>
        <SimpleForm>
            <GeoForm/>
        </SimpleForm>
    </Edit>
)